enum TipoEtapa {
    Inicial = 0,
    Intermediario = 1,
    Final = 2
}

export default TipoEtapa;